exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 768px) {\n  .categoryTagsCategories_showMoreSelected {\n      max-height: 200px;\n      overflow: hidden;\n      transition: max-height 0.5s ease-in-out;\n  }\n}\n\n.categoryTagsCategories_showMoreUnSelected{\n    max-height: 50px;\n    overflow: hidden;\n    transition: max-height 0.3s ease-in-out;\n}\n", ""]);

// exports
